import React from "react";
import { bind } from "decko";

import Util from "./include/Util";
import DialogOverlay from "./DialogOverlay";
import L1PlayerSelector from "./L1PlayerSelector";

/**
 * UI for creating a substitution event event
 */
export default class SubstitutionEventDialog extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            playerIn: null,
            playerOut: null,
        };
    }

    getTag () {
        let tag = {
            action: "substitution",
            team: {
                type: "team",
                id: this.props.selectedTeam.id,
                value: this.props.selectedTeam.name
            }
        };
        if (this.state.playerIn !== null) {
            tag["player in"] = {
                type: "player",
                id: this.state.playerIn.id,
                value: this.state.playerIn.value
            }
        }
        if (this.state.playerOut !== null) {
            tag["player out"] = {
                type: "player",
                id: this.state.playerOut.id,
                value: this.state.playerOut.value
            }
        }
        return tag;
    }

    getDescription (tag) {
        if (tag === undefined) tag = this.getTag();
        return Util.createAutomaticTitle(tag, this.props.game);
    }

    @bind
    save () {
        let tag = this.getTag();
        this.props.onSave(tag, undefined, this.getDescription(tag));
    }

    render () {

        return (
            <DialogOverlay
                hotkeyHandler={this.props.hotkeyHandler}
                onSubmit={this.save}
                onCancel={this.props.onCancel}>

                <div className="row" style={{marginBottom: "16px"}}>
                    <div className="col-xs-12 text-center text-capitalize">
                        {this.getDescription()}
                    </div>
                    <div className="col-xs-12 text-center" style={{marginTop: "10px"}}>
                        <div className="col-xs-12 text-center text-capitalize">
                            Player Out
                        </div>
                        <L1PlayerSelector
                            player={this.state.playerOut}
                            lineup={this.props.lineup}
                            playersOnPitch={this.props.playersOnPitch}
                            playersUnavailable={this.props.playersUnavailable}
                            selectedTeam={this.props.selectedTeam}
                            onChange={player => this.setState({playerOut: player})}
                        />
                    </div>
                    <div className="col-xs-12 text-center" style={{marginTop: "10px"}}>
                        <div className="col-xs-12 text-center text-capitalize">
                            Player In
                        </div>
                        <L1PlayerSelector
                            player={this.state.playerIn}
                            lineup={this.props.lineup}
                            playersOnPitch={this.props.playersOnPitch}
                            playersUnavailable={this.props.playersUnavailable}
                            invertUnavailable
                            selectedTeam={this.props.selectedTeam}
                            onChange={player => this.setState({playerIn: player})}
                        />
                    </div>
                </div>
            </DialogOverlay>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/SubstitutionEventDialog.js